import React, { Component } from 'react';
import './panelLayout.scss';

import { Route } from 'react-router';

import {Link, NavLink} from 'react-router-dom';

import {Layout, Menu, message, Icon} from 'antd';


import account from '../account/account';
import changePassword from '../changePassword/changePassword';
import credit from '../credit/credit';
import dashboard from '../dashboard/dashboard';
import request from '../request/request';
import transaction from '../transaction/transaction';
import searchBar from "../searchBar";
const { Header, Content, Footer } = Layout;

export default class PanelLayout extends Component {
  state = {
    collapsed: false,
    selectedKeys:null
  };
  onCollapse = (collapsed: boolean) => {
    console.log(collapsed);
    this.setState({ collapsed });
  };
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  };
  logout(){
    localStorage.removeItem('Token');
    localStorage.removeItem('UserData');
    message.success('Successfully logged out of your account.');
  };

  render() {
    return (
      <Layout className="layout">
        {/*<Sider trigger={null} collapsible >*/}
          {/*<div className="logo" />*/}
          {/*<Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>*/}
            {/*<Menu.Item key="1">*/}
              {/*<Icon type="user" />*/}
              {/*<span>nav 1</span>*/}
            {/*</Menu.Item>*/}
            {/*<Menu.Item key="2">*/}
              {/*<Icon type="video-camera" />*/}
              {/*<span>nav 2</span>*/}
            {/*</Menu.Item>*/}
            {/*<Menu.Item key="3">*/}
              {/*<Icon type="upload" />*/}
              {/*<span>nav 3</span>*/}
            {/*</Menu.Item>*/}
          {/*</Menu>*/}
        {/*</Sider>*/}

        <Header
          style={{
            position: 'fixed',
            background: '#001528 !important',
            zIndex: 2,
            width: '100%',
            textAlign: 'right',


          }}
        >
          <div className="logo" />
          <Menu
            theme="dark"
            mode="horizontal"
            selectable={false}
            style={{ lineHeight: '64px' }}
          >

            <Menu.Item key="1">
              <NavLink   to={'/'}>Home</NavLink>
            </Menu.Item>
            <Menu.Item key="2">
              <NavLink  activeClassName={'activeManu'} to={'/panel/search'}>
                <span>
                Analytics
                </span>
                </NavLink>
            </Menu.Item>


            <Menu.Item key="8">
              <NavLink activeClassName={'activeManu'}  to={'/panel/account/profile'}>
                <Icon type="user" />
                <span> Profile </span></NavLink>
            </Menu.Item>

            <Menu.Item key="9">
              <NavLink   onClick={() => this.logout()} to={'/'}> <span> Logout </span></NavLink>
            </Menu.Item>
          </Menu>
        </Header>
        <Content style={{ padding: '0 20px', marginTop: 75 }}>
          <div style={{   minHeight: '82vh',height:'auto' }}>

            <Route path="/panel/search" component={searchBar} />

            <Route path="/panel/account" component={account} />
            <Route path="/panel/changePassword" component={changePassword} />
            <Route path="/panel/credit" component={credit} />
            <Route path="/panel/dashboard" component={dashboard} />
            <Route path="/panel/request" component={request} />
            <Route path="/panel/transaction" component={transaction} />


          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
        </Footer>
      </Layout>
    );
  }
}
